module.exports = __webpack_public_path__ + "static/img/klab-advantage.ef4fc12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/klab-advantage.png
// module id = rmLV
// module chunks = 0